import { render, staticRenderFns } from "./punchStatistics.vue?vue&type=template&id=a6073584"
import script from "./punchStatistics.vue?vue&type=script&lang=js"
export * from "./punchStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports